<template>
  <span class="relative inline-block shrink-0" :style="{ width: `${size}px`, height: `${size}px` }" aria-hidden="true">
    <Star :size="size" class="absolute inset-0 text-amber-500" />
    <span data-rating-star-fill class="absolute inset-0 overflow-hidden" :style="{ width: `${pct}%` }">
      <Star :size="size" class="text-amber-500 fill-current" />
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Star } from "lucide-vue-next";

// Одна звезда рейтинга: закрашена слева направо на rating / 5 (4.5 → 90%).
// Комментарий не в <template>: иначе корнем станет фрагмент, а не <span>.
const props = withDefaults(defineProps<{ rating?: number | null; size?: number }>(), { size: 14 });
const pct = computed(() => Math.max(0, Math.min(1, (props.rating ?? 0) / 5)) * 100);
</script>
